import {
  ROLE_STAFF,
  ROLE_RESEARCH,
  ROLE_PATENT_SPECIALIST,
  ROLE_LOGISTIC_MANGER,
  ROLE_ADMIN,
  ROLE_LOGISTIC_MANGER_READ,
  ROLE_SOCIAL_MEDIA_SCRAPER_ADMIN,
} from 'App/constants/Roles';
import {
  CMS_TAB_PRODS_DRAFT,
  SUB_PRODUCTS_VAPING_DEV,
  SUB_ORDERS_SA,
  SUB_ORDERS_WS,
  SUB_WEBSITE_DEALS,
  SUB_INFO_REQUESTS,
  SUB_ANALYZE_REQUESTS,
  SUB_ATTENDING_REQUESTS,
} from 'App/utils/Collections';

const { NODE_ENV } = process.env;
const isProd = NODE_ENV === 'production';

const routes = [
  {
    component: () => import('Views/PasswordReset'),
    name: 'PasswordReset',
    path: '/reset-password/:token',
    meta: {
      isPublic: true,
    },
  },
  {
    component: () => import('Views/Prices'),
    name: 'Prices',
    path: '/prices',
    meta: {
      isPublic: true,
    },
  },
  {
    components: {
      public: () => import('Views/Welcome'),
      default: () => import('Views/Dashboard'),
    },
    name: 'Welcome',
    path: '/',
    meta: {
      isPublic: true,
    },
  },
  {
    component: () => import('Views/Events'),
    name: 'Calendar',
    path: '/events',
    meta: {
      backPage: 'Welcome',
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'Events',
    path: '/events/:id',
    props: {
      category: 'events',
    },
    meta: {
      backPage: 'Calendar',
      name: 'Event',
    },
  },
  {
    component: () => import('Views/Classification'),
    name: 'Classification',
    path: '/classification',
    meta: {
      backPage: 'Welcome',
    },
  },
  {
    component: () => import('Views/News'),
    name: 'News',
    path: '/news',
    meta: {
      backPage: 'Welcome',
    },
  },
  {
    component: () => import('Views/Researches'),
    name: 'Research',
    path: '/research',
    meta: {
      restrictions: [ROLE_STAFF, ROLE_RESEARCH],
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/Search'),
    name: 'Search',
    path: '/search',
    meta: {
      backPage: 'Welcome',
    },
  },
  {
    component: () => import('Views/NewsOverview'),
    name: 'NewsOverview',
    path: '/news/:id',
    meta: {
      backPage: 'News',
      name: 'Overview',
    },
  },
  {
    component: () => import('Views/ReportMaker'),
    name: 'ReportMaker',
    path: '/reportMaker',
  },
  {
    component: () => import('Views/Dashboard'),
    name: 'Dashboard',
    path: '/dashboard',
  },
  {
    component: () => import('Views/profile/ProfileBookmarks'),
    name: 'ProfileBookmarks',
    path: '/profile/bookmarks',
    meta: {
      name: 'Bookmarks',
    },
  },
  {
    component: () => import('Views/profile/ProfileFilters'),
    name: 'ProfileFilters',
    path: '/profile/filters',
    meta: {
      name: 'Filters',
    },
  },
  {
    component: () => import('Views/profile/Account'),
    name: 'Profile',
    path: '/profile',
  },
  {
    component: () => import('Views/profile/OrdersAndRequests'),
    name: 'OrdersAndRequests',
    path: '/orders_and_requests/:tab(orders|recommended-products|analysis|information-requests|attending-requests)',
    meta: {
      name: 'Orders And Requests',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'BrandInfo',
    path: '/brands/:id(\\d+)',
    props: {
      category: 'brands',
    },
    meta: {
      backPage: '/brands',
      name: 'Brand Info',
      useBreadcrumbsPagination: true,
      interceptBreadcrumbsData: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Brands',
    path: '/brands',
    props: {
      category: 'brands',
    },
    meta: {
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'ProductInfo',
    path: '/products/:id(\\d+)',
    props: {
      category: 'products',
    },
    meta: {
      backPage: 'Products',
      name: 'Product Info',
      interceptBreadcrumbsData: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Products',
    path: '/products',
    props: {
      category: 'products',
    },
    meta: {
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Variations',
    path: '/product-variations',
    props: {
      category: 'product-variations',
    },
    meta: {
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Components',
    path: '/components',
    props: {
      category: 'components',
      caption: 'Components (Beta)',
    },
    meta: {
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'ComponentInfo',
    path: '/components/:id',
    props: {
      category: 'components',
      caption: 'Components (Beta)',
    },
    meta: {
      backPage: 'Components',
      name: 'Component Info',
      interceptBreadcrumbsData: true,
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'CompanyInfo',
    path: '/companies/:id(\\d+)',
    props: {
      category: 'companies',
    },
    meta: {
      backPage: '/companies',
      name: 'Company Info',
      useBreadcrumbsPagination: true,
      interceptBreadcrumbsData: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Companies',
    path: '/companies',
    props: {
      category: 'companies',
    },
    meta: {
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Contacts',
    path: '/contacts',
    props: {
      category: 'contacts',
    },
    meta: {
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'ContactInfo',
    path: '/contacts/:id',
    props: {
      category: 'contacts',
    },
    meta: {
      backPage: 'Contacts',
      name: 'Contact Info',
      interceptBreadcrumbsData: true,
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'TrademarkInfo',
    path: '/trademarks/:id(\\d+)',
    props: {
      category: 'trademarks',
    },
    meta: {
      backPage: '/trademarks',
      name: 'Trademark Info',
      useBreadcrumbsPagination: true,
      interceptBreadcrumbsData: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Trademarks',
    path: '/trademarks',
    props: {
      category: 'trademarks',
    },
    meta: {
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'Patents',
    path: '/patents',
    props: {
      category: 'patents',
    },
    meta: {
      backPage: 'Welcome',
      useBreadcrumbsPagination: true,
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'PatentInfo',
    path: '/patents/:id',
    props: {
      category: 'patents',
    },
    meta: {
      backPage: 'Patents',
      name: 'Patent Info',
      interceptBreadcrumbsData: true,
    },
  },
  {
    component: () => import('Views/Agreement'),
    name: 'UserAgreement',
    path: '/user_agreement',
    props: {
      type: 'user',
    },
    meta: {
      name: 'User Agreement',
    },
  },
  {
    component: () => import('Views/Agreement'),
    name: 'SubscriptionAgreement',
    path: '/subscription_agreement',
    props: {
      type: 'subscription',
    },
    meta: {
      name: 'Subscription Agreement',
    },
  },
  {
    component: () => import('Views/ItemsList'),
    name: 'StandingReports',
    path: '/standing_reports',
    props: {
      category: 'standing_reports',
      caption: 'Standing Reports',
    },
    meta: {
      backPage: 'Welcome',
      name: 'Standing Reports',
      useBreadcrumbsPagination: true,
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    component: () => import('Views/ItemInfo'),
    name: 'StandingReportInfo',
    path: '/standing_reports/:id',
    props: {
      category: 'standing_reports',
      caption: 'Standing Report',
    },
    meta: {
      backPage: 'StandingReports',
      name: 'Standing Report Info',
      interceptBreadcrumbsData: true,
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    path: '/standing_reports/:id/section',
    redirect: (route) => ({
      name: 'StandingReportInfo',
      id: route.params.id,
    }),
  },
  {
    component: () => import('Components/standing-report/standing-report-section'),
    name: 'StandingReportSectionCreate',
    path: '/standing_reports/:id/section/create',
    props: true,
    meta: {
      backPage: 'StandingReports',
      name: 'Create standing report',
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    component: () => import('Components/standing-report/standing-report-section'),
    name: 'StandingReportSectionUpdate',
    path: '/standing_reports/:id/section/:sectionId/update',
    props: true,
    meta: {
      backPage: 'StandingReports',
      name: 'Update standing report',
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    component: () => import('Components/standing-report/standing-report-section-products'),
    name: 'StandingReportSectionProducts',
    path: '/standing_reports/:id/section/:sectionId/products',
    props: true,
    meta: {
      backPage: 'StandingReportInfo',
      name: 'Products',
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    component: () => import('Components/standing-report/standing-report-add-products'),
    name: 'StandingReportAddProducts',
    path: '/StandingReportAddProducts',
    meta: {
      backPage: 'StandingReportInfo',
      name: 'Add product',
      restrictions: [ROLE_STAFF],
      redirectPage: '/',
    },
  },
  {
    path: '/standing_reports/:id/section/:sectionId',
    redirect: (route) => ({
      name: 'StandingReportInfo',
      id: route.params.id,
    }),
  },
  {
    component: () => import('@/views/cms/CmsViewIndex'),
    name: 'CMS',
    path: '/cms',
    redirect: () => {
      return {
        name: 'CMSSubList',
        params: { tab: CMS_TAB_PRODS_DRAFT, sub: SUB_PRODUCTS_VAPING_DEV },
      };
    },
    children: [
      {
        path: 'assistant',
        redirect: `assistant/${SUB_PRODUCTS_VAPING_DEV}`,
        meta: {
          name: 'Assistant',
        },
      },
      {
        path: 'assistant/:subcategory([\\w-]+)',
        name: 'Assistant',
        components: {
          cms: () => import('@/views/cms/assistant/Assistant'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: '/cms',
          name: 'Assistant',
        },
      },
      {
        path: 'social-media-scraper',
        name: 'SocialMediaScraper',
        components: {
          cms: () => import('@/views/cms/CmsSocialMediaScraper'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: '/cms',
        },
      },
      {
        path: 'social-media-scraper/accounts/create',
        name: 'CMSSocialMediaCoreAccountCreate',
        components: {
          cms: () => import('@/views/cms/CmsSocialMediaCoreAccountForm'),
        },
        meta: {
          restriction: [[ROLE_STAFF, ROLE_SOCIAL_MEDIA_SCRAPER_ADMIN]],
          backPage: 'SocialMediaScraper',
          name: 'Create core account',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: 'social-media-scraper/accounts/:id(\\d+)',
        name: 'CMSSocialMediaCoreAccountUpdate',
        components: {
          cms: () => import('@/views/cms/CmsSocialMediaCoreAccountForm'),
        },
        meta: {
          restriction: [[ROLE_STAFF, ROLE_SOCIAL_MEDIA_SCRAPER_ADMIN]],
          backPage: 'SocialMediaScraper',
          name: 'Update core account',
          interceptBreadcrumbsData: true,
        },
      },
      // Core accounts are also listed under the ref_data tab. These two must stay ahead of the
      // generic `:tab(ref_data|...)/:sub` routes below, which would otherwise open CmsViewForm.
      {
        path: ':tab(ref_data)/:sub(core_accounts)/create',
        name: 'CMSRefDataCoreAccountCreate',
        components: {
          cms: () => import('@/views/cms/CmsSocialMediaCoreAccountForm'),
        },
        meta: {
          restriction: [[ROLE_STAFF, ROLE_SOCIAL_MEDIA_SCRAPER_ADMIN]],
          backPage: '/cms/ref_data/core_accounts',
          name: 'Create core account',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(ref_data)/:sub(core_accounts)/:id(\\d+)',
        name: 'CMSRefDataCoreAccountUpdate',
        components: {
          cms: () => import('@/views/cms/CmsSocialMediaCoreAccountForm'),
        },
        meta: {
          restriction: [[ROLE_STAFF, ROLE_SOCIAL_MEDIA_SCRAPER_ADMIN]],
          backPage: '/cms/ref_data/core_accounts',
          name: 'Update core account',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(newsletter-emails)',
        name: 'NewsletterEmails',
        components: {
          cms: () => import('@/views/cms/CmsNewsletterEmails'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: '/cms',
        },
      },
      {
        path: ':tab(information_sources)',
        name: 'CMSInformationSources',
        components: {
          cms: () => import('@/views/cms/CmsInformationSources'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: '/cms',
        },
      },
      {
        path: ':tab(stats_reports)/user/:id',
        components: {
          cms: () => import('Views/cms/staff-stats/UserStats'),
        },
        name: 'CMSStaffStatsUserStats',
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'Welcome',
          name: 'User Stats',
        },
      },
      {
        path: ':tab(stats_reports)/:cat([\\w-]+)',
        components: {
          cms: () => import('@/views/cms/CmsViewList'),
        },
        name: 'CMSStaffStats',
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'Welcome',
          name: 'Staff Stats',
        },
      },
      {
        path: ':tab(stats_reports)/:cat/:id/:action?',
        components: {
          cms: () => import('Views/cms/staff-stats/StatsDetails'),
        },
        name: 'CMSStaffStatsDetails',
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'Welcome',
          name: 'Stats Details',
        },
      },
      {
        path: ':tab(ref_data|components|products_draft|products)/:sub([\\w-]+)',
        name: 'CMSSubList',
        components: {
          cms: () => import('@/views/cms/CmsViewList'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'Welcome',
          name: 'List',
          useBreadcrumbsPagination: true,
        },
        strict: true,
      },
      {
        path: ':tab(crm)/:sub(orders-smoking-alternatives|orders-wellness-and-stimulation)/:subsub(orders|customers|courier_delivery_services|projects|agents)',
        name: 'CMSOrdersSubList',
        components: {
          cms: () => import('@/views/cms/CmsViewList'),
        },
        meta: {
          restrictions: {
            param: 'sub',
            map: {
              [SUB_ORDERS_SA]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
              [SUB_ORDERS_WS]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
            },
          },
          backPage: 'Welcome',
          name: 'Orders List',
          useBreadcrumbsPagination: true,
        },
      },
      {
        path: ':tab(crm)/:sub(website_deals)/:subsub([\\w-]+)',
        name: 'CMSWebsiteDealsSubList',
        components: {
          cms: () => import('@/views/cms/CmsViewList'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
          backPage: 'Welcome',
          name: 'Website Deals List',
          useBreadcrumbsPagination: true,
        },
      },
      {
        path: ':tab(crm)/:sub(orders-smoking-alternatives|orders-wellness-and-stimulation)/:subsub(orders)/create',
        name: 'CMSProductOrderCreateSub',
        components: {
          cms: () => import('@/views/cms/CmsProductOrderForm'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSOrdersSubList',
          name: 'Create order',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(website_deals)/:subsub([\\w-]+)/create',
        name: 'CMSWebsiteDealsSubCreate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: [ROLE_ADMIN],
          backPage: 'CMSWebsiteDealsSubList',
          name: 'Create',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(info_requests|analyze_requests|attending_requests)/create',
        name: 'CMSCrmSubCreate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSOrders',
          name: 'Create',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(ref_data|components|products_draft|products)/:sub([\\w-]+)/create',
        name: 'CMSSubCreate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'CMSSubList',
          name: 'Create',
          interceptBreadcrumbsData: true,
        },
        strict: true,
      },
      {
        path: ':tab(crm)/:sub(orders-smoking-alternatives|orders-wellness-and-stimulation)/:subsub(customers|courier_delivery_services|projects|agents)/create',
        name: 'CMSCrmNestedSubCreate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSOrdersSubList',
          name: 'Create',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(orders-smoking-alternatives|orders-wellness-and-stimulation)/:subsub(orders)/:id(\\d+)',
        name: 'CMSProductOrderUpdate',
        components: {
          cms: () => import('@/views/cms/CmsProductOrderForm'),
        },
        meta: {
          restrictions: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSOrdersSubList',
          name: 'Update Order',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(orders-smoking-alternatives|orders-wellness-and-stimulation)/:subsub(customers|courier_delivery_services|projects|agents)/:id(\\d+)',
        name: 'CMSCrmNestedSubUpdate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSOrdersSubList',
          name: 'Update',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(info_requests|analyze_requests|attending_requests)/:id(\\d+)',
        name: 'CMSCrmSubUpdate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSOrders',
          name: 'Update',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(website_deals)/:subsub([\\w-]+)/:id(\\d+)',
        name: 'CMSWebsiteDealsSubUpdate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: [ROLE_LOGISTIC_MANGER],
          backPage: 'CMSWebsiteDealsSubList',
          name: 'Update',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(ref_data|components|products_draft|products|info_requests|analyze_requests|attending_requests)/:sub([\\w-]+)/:id(\\d+)',
        name: 'CMSSubUpdate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'CMSSubList',
          name: 'Update',
          interceptBreadcrumbsData: true,
        },
        strict: true,
      },
      {
        path: ':tab([\\w-]+)',
        name: 'CMSList',
        components: {
          cms: () => import('@/views/cms/CmsViewList'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'Welcome',
          name: 'CMS List',
          useBreadcrumbsPagination: true,
        },
      },
      {
        path: ':tab(patent_research)/create',
        name: 'CMSPatentResearchCreate',
        components: {
          cms: () => import('@/views/cms/CmsPatentResearchForm'),
        },
        meta: {
          restriction: ROLE_PATENT_SPECIALIST,
          backPage: 'CMSList',
          name: 'Create Patent Research',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(crm)/:sub(orders-smoking-alternatives|orders-wellness-and-stimulation|website_deals|info_requests|analyze_requests|attending_requests)',
        components: {
          cms: () => import('@/views/cms/CmsViewList'),
        },
        name: 'CMSOrders',
        meta: {
          restrictions: {
            param: 'sub',
            map: {
              [SUB_ORDERS_SA]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
              [SUB_ORDERS_WS]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
              [SUB_WEBSITE_DEALS]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
              [SUB_INFO_REQUESTS]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
              [SUB_ANALYZE_REQUESTS]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
              [SUB_ATTENDING_REQUESTS]: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
            },
          },
          backPage: 'Welcome',
          name: 'CMS Orders',
          useBreadcrumbsPagination: true,
        },
      },
      {
        path: ':tab([\\w-]+)/create',
        name: 'CMSCreate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: ROLE_STAFF,
          name: 'Create',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(patent_research)/:id(\\d+)',
        name: 'CMSPatentResearchUpdate',
        components: {
          cms: () => import('@/views/cms/CmsPatentResearchForm'),
        },
        meta: {
          restriction: ROLE_PATENT_SPECIALIST,
          backPage: 'CMSList',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(researches)/:id(\\d+)',
        name: 'CMSResearchUpdate',
        components: {
          cms: () => import('@/views/cms/CmsResearchForm'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'CMSList',
          name: 'Update Patent Research',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(newsletter-emails)/:id(\\d+)',
        name: 'CMSNewsletterEmailsUpdate',
        components: {
          cms: () => import('@/views/cms/CmsNewsletterEmailsForm'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'NewsletterEmails',
          name: 'Update Newsletter Emails',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab(information_sources)/:id(\\d+)',
        name: 'CMSInformationSourcesUpdate',
        components: {
          cms: () => import('Views/cms/CmsInformationSourcesDetails.vue'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'CMSInformationSources',
          name: 'Products Information Source',
          interceptBreadcrumbsData: true,
        },
      },
      {
        path: ':tab([\\w-]+)/:id(\\d+)',
        name: 'CMSUpdate',
        components: {
          cms: () => import('@/views/cms/CmsViewForm'),
        },
        meta: {
          restriction: ROLE_STAFF,
          backPage: 'CMSSubList',
          name: 'CMS Update',
          interceptBreadcrumbsData: true,
        },
      },
    ],
    meta: {
      restriction: ROLE_STAFF,
    },
  },
  {
    component: () => import('Views/StaffStatsPage'),
    name: 'StaffStats',
    path: '/stats/:cat/:id/:action',
    meta: {
      restriction: ROLE_STAFF,
      backPage: 'Welcome',
      name: 'Staff Stats',
    },
  },
  {
    component: () => import('Views/Error'),
    name: 'Error',
    path: '/:code',
    meta: {
      isPublic: true,
    },
  },
];

if (isProd) {
  routes.push({
    path: '*',
    redirect: '/404',
  });
}

export default routes;
